angular
  .module('webApp', [
    'webApp.controllers',
    'webApp.services',
    'webApp.filters',

    'ui.router',

    'ngSanitize',
    'ngTouch',
    'ngAnimate',

    'ace.apiService',
    'ace.helperService',
    'ace.errorService',
    'ace.generalFilters',

    'hj.imgCheck',
    'hj.gsapifyRouter',
    'hj.nearBottom',
    'hj.wheelStep',
    'hj.uiSrefFastclick',
    'hj.scrollify',
    'hj.preventInertia',

    // 'LocalStorageModule',
    'angular-images-loaded',
    'angular-loading-bar',
    'duScroll',
    'swipe',
  ])

  .constant('appConfig', appConfig)

  // .value('duScrollEasing', easing.easeInOutQuint)
  .value('duScrollDuration', 800)
  .value('duScrollOffset', 75)

  .config(function (
    $stateProvider,
    $locationProvider,
    $urlRouterProvider,
    $httpProvider,
    $provide,
    $sceDelegateProvider,
    $sceProvider,
    $anchorScrollProvider,
    $uiViewScrollProvider,
    gsapifyRouterProvider,
    cfpLoadingBarProvider
  ) {
    $locationProvider.html5Mode(true);

    // Disable security to allow untrusted urls...
    // $sceProvider.enabled(false)

    // ... or whitelist them
    $sceDelegateProvider.resourceUrlWhitelist([
      'self',
      'https://*.s3.amazonaws.com/**',
      'https://*.youtube.com/**',
      'http://*.fokus.io/**',
      'http://*.vimeo.com/**',
      '//*.embedly.com/**',
      '//*.cdninstagram.com/**',
    ]);

    // Overrides

    // Kill default ng-src
    // $provide.decorator('ngSrcDirective', ['$delegate', '$sniffer',
    //     function($delegate, $sniffer) {
    //         var directive = $delegate[0].compile = function(element, attrs) {}
    //         return $delegate
    //     }
    // ])

    // Kill ui-router scoll into view
    // $uiViewScrollProvider.useAnchorScroll()
    // $anchorScrollProvider.disableAutoScrolling()

    // Send data as form vars by default
    // $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'

    // Routing

    $urlRouterProvider.otherwise('/404');

    // Remove trailing slash
    $urlRouterProvider.rule(function ($injector, $location) {
      var path = $location.url();

      if (path[path.length - 1] === '/') {
        return path.replace(/\/$/, '');
      }

      if (path.indexOf('/?') > 0) {
        return path.replace('/?', '?');
      }

      return false;
    });

    // Providers

    // cfpLoadingBarProvider.latencyThreshold = 0
    cfpLoadingBarProvider.includeSpinner = false;
    cfpLoadingBarProvider.includeBar = true;

    // Transitions

    gsapifyRouterProvider.defaults = {
      enter: 'fadeDelayed',
      leave: 'fade',
    };

    gsapifyRouterProvider.transition('fade', {
      duration: 0.4,
      css: {
        opacity: 0,
      },
    });

    gsapifyRouterProvider.transition('fadeDelayed', {
      duration: 0.4,
      delay: 0.6,
      css: {
        opacity: 0,
      },
    });

    gsapifyRouterProvider.transition('noneDelayed', {
      duration: 0,
      delay: 1.5,
      css: {
        opacity: 0,
      },
    });

    gsapifyRouterProvider.transition('slideAboveOut', {
      duration: 0.5,
      delay: 1,
      ease: 'Quint.easeOut',
      css: {
        y: '-100%',
      },
    });

    gsapifyRouterProvider.transition('slideAboveIn', {
      duration: 0.5,
      delay: 0,
      ease: 'Quint.easeIn',
      css: {
        y: '-100%',
      },
    });

    gsapifyRouterProvider.transition('slideAbove', {
      duration: 0.8,
      delay: 0,
      ease: 'Quint.easeInOut',
      css: {
        y: '-100%',
      },
    });

    gsapifyRouterProvider.transition('slideBelow', {
      duration: 0.8,
      delay: 0,
      ease: 'Quint.easeInOut',
      css: {
        y: '100%',
        opacity: 0,
      },
    });

    gsapifyRouterProvider.transition('slideBelowDelayed', {
      duration: 0.4,
      delay: 0.4,
      ease: 'Quint.easeOut',
      css: {
        y: '10%',
        opacity: 0,
      },
    });

    // States

    var states = [];

    states.push({
      name: '404',
      url: '/404',
      views: {
        main: {
          templateUrl: '/templates/404.html',
          controller: /* @ngInject*/ function ($rootScope, $state, $timeout) {
            $rootScope.statusCode = 404;

            $timeout(function () {
              $state.go('main.home');
            }, 2000);
          },
        },
      },
    });

    states.push({
      name: 'main',
      abstract: true,
      resolve: {
        metadata: /* @ngInject*/ function ($rootScope, ApiService) {
          return ApiService.metadata().then(function (metadata) {
            $rootScope.metadata = metadata;

            $rootScope.pageDescription = metadata.description;

            return metadata;
          });
        },
      },
      views: {
        main: {},
        menu: {
          templateUrl: '/templates/main-menu.html',
        },
        logo: {
          templateUrl: '/templates/logo.html',
        },
      },
    });

    states.push({
      name: 'main.home',
      url: '/',
      resolve: {
        home: /* @ngInject*/ function (ApiService) {
          return ApiService.entitySearchOne({
            q: 'schema:homePage',
            children: 1,
          });
        },
      },
      views: {
        content: {
          templateUrl: '/templates/home.html',
          controllerAs: 'ctrl',
          controller: /* @ngInject*/ function (
            $rootScope,
            $state,
            $document,
            HelperService,
            home
          ) {
            var ctrl = this;

            $rootScope.pageTitle = $rootScope.pageUrl = null;

            ctrl.landscapeImage = HelperService.thumbnailSrc(
              HelperService.shuffle(home.fields.landscapeImages)[0].thumbnail,
              'h:1500;q:80'
            );
            ctrl.portraitImage = HelperService.thumbnailSrc(
              HelperService.shuffle(home.fields.portraitImages)[0].thumbnail,
              'h:1500;q:80'
            );

            ctrl.wheelStep = function (delta) {
              if (delta < 0) {
                $state.go('main.projectIndex');
              }
            };

            ctrl.swipeUp = function ($event) {
              $state.go('main.projectIndex');
            };

            ctrl.newsflash = home.fields.text.html;
          },
        },
        'menu@': {},
      },
      data: {
        'gsapifyRouter.content': {
          enter: {
            in: {
              transition: 'slideAbove',
              priority: 2,
            },
            out: {
              transition: 'slideBelow',
              priority: 2,
            },
          },
          leave: {
            in: {
              transition: 'slideBelowDelayed',
              priority: 2,
            },
            out: {
              transition: 'slideAbove',
              priority: 2,
            },
          },
        },
      },
    });

    states.push({
      name: 'main.process',
      url: '/process',
      resolve: {
        process: /* @ngInject*/ function (ApiService) {
          return ApiService.entitySearchOne({
            q: 'schema:process',
            children: 2,
          });
        },
      },
      views: {
        content: {
          templateUrl: '/templates/process.html',
          controllerAs: 'ctrl',
          controller: /* @ngInject*/ function (
            $rootScope,
            $document,
            HelperService,
            process
          ) {
            var ctrl = this;

            $rootScope.pageTitle = 'Process';
            // $rootScope.pageUrl = '/process'

            ctrl.process = process;
          },
        },
      },
    });

    states.push({
      name: 'main.about',
      url: '/about',
      resolve: {
        about: /* @ngInject*/ function (ApiService) {
          return ApiService.entitySearchOne({
            q: 'schema:about',
            include_docs: true,
          });
        },
      },
      views: {
        content: {
          templateUrl: '/templates/about.html',
          controllerAs: 'ctrl',
          controller: /* @ngInject*/ function (
            $rootScope,
            $location,
            HelperService,
            about
          ) {
            var ctrl = this;

            $rootScope.pageTitle = 'About';
            // $rootScope.pageUrl = '/about'

            ctrl.about = about;
          },
        },
      },
    });

    states.push({
      name: 'main.projectIndex',
      url: '/projects/all',
      resolve: {
        projects: /* @ngInject*/ function (ApiService) {
          return ApiService.entitySearch({
            q: 'schema:project',
            children: 1,
            sort: 'sort.publishedAt<number>',
          }).then(function (projects) {
            return projects.rows;
          });
        },
      },
      views: {
        content: {
          templateUrl: '/templates/project-index.html',
          controllerAs: 'ctrl',
          controller: /* @ngInject*/ function (
            $rootScope,
            $state,
            HelperService,
            projects
          ) {
            var ctrl = this;

            $rootScope.pageTitle = 'All Projects';
            // $rootScope.pageUrl = '/projects/all'

            ctrl.projects = projects;

            ctrl.back = function () {
              if ($state.history.length) {
                var prevState = $state.history.slice(-1)[0];

                $state.go.apply(null, [prevState.name, prevState.params]);
              } else {
                $state.go('main.projects');
              }
            };
          },
        },
      },
    });

    states.push({
      name: 'main.project',
      url: '/projects/{project:[a-zA-Z0-9_-]{1,200}}?index',
      reloadOnSearch: false,
      resolve: {
        projects: /* @ngInject*/ function (ApiService) {
          return ApiService.entitySearch({
            q: 'schema:project',
            children: 1,
            sort: 'sort.publishedAt<number>',
          }).then(function (projects) {
            return projects.rows;
          });
        },
      },
      views: {
        content: {
          templateUrl: '/templates/project.html',
          controllerAs: 'ctrl',
          controller: /* @ngInject*/ function (
            $rootScope,
            $scope,
            $state,
            $stateParams,
            $timeout,
            HelperService,
            projects
          ) {
            var ctrl = this;

            ctrl.scrollSpeed = 0;

            var project = projects.filter(function (project) {
              return project.slug === $stateParams.project;
            })[0];

            if (!project) {
              $state.go('404');
              throw new Error('Project not found');
            }

            $rootScope.pageTitle = project.title;
            // $rootScope.pageUrl = '/project/' + project.slug

            ctrl.showImage = function (i, pane) {
              //   return Math.abs(ctrl.currentPane - i) < 3;
              return true;
            };

            ctrl.panes = [];

            ctrl.panes.push({
              type: 'text',
              projectSlug: project.slug,
              title: project.title,
              text: project.fields.text,
            });

            project.fields.assets.forEach(function (asset) {
              ctrl.panes.push({
                type: 'image',
                projectSlug: project.slug,
                thumbnail: asset.thumbnail,
              });
            });

            ctrl.title = project.title;

            ctrl.nextProject = HelperService.getAdjacent(projects, {
              slug: project.slug,
            }).previous.slug;

            ctrl.currentPane = 0;

            $scope.$on('scrollify:change', function (event, args) {
              ctrl.currentPane = args.index;

              $state.go('main.project', {
                index: ctrl.currentPane,
              });
            });

            $timeout(function () {
              if ($stateParams.index) {
                $scope.$broadcast('scrollify:goTo', {
                  pane: $stateParams.index,
                  speed: 0,
                });
              }

              // wait for page transition
              $timeout(function () {
                ctrl.scrollSpeed = 800;
              }, 600);
            });

            ctrl.next = function () {
              $scope.$broadcast('scrollify:next');
            };

            ctrl.prev = function () {
              $scope.$broadcast('scrollify:prev');
            };
          },
        },
      },
    });

    states.forEach(function (state) {
      $stateProvider.state(state.name, state);
    });
  })

  .run(function (
    $rootScope,
    $state,
    $window,
    $document,
    $location,
    $log,
    HelperService,
    appConfig
  ) {
    // Globals

    $rootScope.appConfig = appConfig;

    $rootScope.now = new Date();
    $rootScope.$state = $state;
    $rootScope.$location = $location;

    $rootScope.mobile = $window.Detectizr.device.type === 'mobile';
    $rootScope.tablet = $window.Detectizr.device.type === 'tablet';

    $rootScope.$helper = HelperService;

    // Initialise

    $window.viewportUnitsBuggyfill.init({
      force: $window.Detectizr.device.type !== 'desktop',
      hacks: $window.viewportUnitsBuggyfillHacks,
    });

    // State events

    $rootScope.$on('$stateChangeError', function (
      $event,
      toState,
      toParams,
      fromState,
      fromParams,
      error
    ) {
      $event.preventDefault();
      $log.error(error.stack);
    });

    $rootScope.$on('$stateChangeSuccess', function (
      $event,
      toState,
      toParams,
      fromState,
      fromParams
    ) {
      $rootScope.stateName = toState.name;

      if (typeof ga !== 'undefined') {
        ga('send', 'pageview', {
          page: $location.path(),
        });
      }
    });

    // $rootScope.$on('gsapifyRouter:leaveSuccess', function (event, element) {
    //   var view = element[0].getAttribute('ui-view');

    //   if (view === 'content') {
    //     $document.scrollTo(0, 0);
    //   }
    // });

    $rootScope.$on('$stateChangeSuccess', function () {
      $document.scrollTo(0, 0);
    });
  });
